/* eslint flowtype/require-valid-file-annotation: 0 */

const instance = Symbol('storeInstance');

const StoreSingleton = {
  [instance]: undefined,

  get instance() {
    return this[instance];
  },

  set instance(newStore) {
    this[instance] = newStore;
    return newStore;
  },

  set(newStore) {
    this.instance = newStore;
    return newStore;
  },
};

export default StoreSingleton;
